import React, { useEffect, useState } from "react";
import "./App.css";

// Import components
import Header from "./components/Header";
import Hero from "./components/Hero";
import Projects from "./components/Projects";
import Awareness from "./components/Awareness";
import About from "./components/About";
import Gallery from "./components/Gallery";
import Footer from "./components/Footer";

function App() {
  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll("section");
      sections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        if (rect.top <= 100 && rect.bottom >= 100) {
          setActiveSection(section.id);
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    element.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="App">
      <Header scrollToSection={scrollToSection} activeSection={activeSection} />
      <Hero scrollToSection={scrollToSection} />
      <Projects />
      <Awareness />
      <About />
      <Gallery />
      <Footer />
    </div>
  );
}

export default App;
